import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  // {
  //   navCap: 'Home',
  // },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboard',
  },
  {
  displayName: 'Financial Planning',
    iconName: 'file-pencil',  // Use 'currency-dollar' for Tabler Icons
    route: '/ui-components/riskprofile',
  },
  
  // {
  //   navCap: 'Ui Components',
  // },
  {
    displayName: 'Mutual Fund',
    iconName: 'businessplan',
    route: '/ui-components/badge',
  },
  // {
  //   displayName: 'AMC Master',
  //   iconName: 'poker-chip',
  //   route: '/ui-components/chips',
  // },
  {
    displayName:'Equity',
    iconName:'trending-up',
        route:'/ui-components/equity'
  },
  {
    displayName: 'Fixed Income',
    iconName: 'layout-navbar-expand',
    route: '/ui-components/fixedincomedashboard',
  },
  {
    displayName: 'Other Assets',
    iconName: 'list',
    route: '/ui-components/otherassetdashboard',
  },
  {
    displayName: 'Reports',
    iconName: 'report',
    route: '/ui-components/mfreport',
  },
  {
    displayName: 'Vault',
    iconName: 'briefcase',
    route: '/ui-components/vault',
  },
  // {
  //   displayName: 'RD Calculator',
  //   iconName: 'report',
  //   route: '/ui-components/rdcal',
  // },
  // {
  //   displayName: 'sipcal',
  //   iconName: 'report',
  //   route: '/ui-components/sipcal',
  // },
  // {
  //   displayName: 'fdcal',
  //   iconName: 'report',
  //   route: '/ui-components/fdcal',
  // },
  // {
  //   displayName: 'gratuitycal',
  //   iconName: 'report',
  //   route: '/ui-components/gratuitycal',
  // },
  // {
  //   displayName: 'emical',
  //   iconName: 'report',
  //   route: '/ui-components/emical',
  // },
  // {
  //   displayName: 'lumpsumcal',
  //   iconName: 'report',
  //   route: '/ui-components/lumpsumcal',
  // },
  // {
  //   displayName: 'retirement',
  //   iconName: 'report',
  //   route: '/ui-components/retirement',
  // },
  {
    displayName: 'Calculators',
    iconName: 'calculator',
    route: '/ui-components/calculator',
  },
  
  // {
  //   displayName: 'nestedtable',
  //   iconName: 'tooltip',
  //   route: '/ui-components/nestedtable',
  // },
  // {
    
  //   navCap: 'Auth',
  // },
  // {
  //   displayName: 'Login',
  //   iconName: 'lock',
  //   route: '/authentication/login',
  // },
  // {
  //   displayName: 'Register',
  //   iconName: 'user-plus',
  //   route: '/authentication/register',
  // },
  // {
  //   navCap: 'Extra',
  // },
  // {
  //   displayName: 'Icons',
  //   iconName: 'mood-smile',
  //   route: '/extra/icons',
  // },
  // {
  //   displayName: 'Sample Page',
  //   iconName: 'aperture',
  //   route: '/extra/sample-page',
  // },
];
